export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                O
              </div>
              <span className="text-background-50 font-semibold text-base">
                OOPBuy Spreadsheet
              </span>
            </div>
            <p className="text-background-400 text-xs md:text-sm leading-relaxed">
              Die deutsche Informationsplattform für OOPBuy Spreadsheet, Produktlisten, Einkaufsanleitungen und sichere Nutzung.
            </p>
          </div>

          <div>
            <h4 className="text-background-100 font-semibold text-sm mb-3">Navigation</h4>
            <div className="flex flex-col gap-2">
              <a href="/" className="text-background-400 hover:text-background-100 text-xs md:text-sm transition-colors whitespace-nowrap">
                Startseite
              </a>
              <a href="/artikel/oopbuy-spreadsheet-guide" className="text-background-400 hover:text-background-100 text-xs md:text-sm transition-colors whitespace-nowrap">
                Guide
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-100 font-semibold text-sm mb-3">Kategorien</h4>
            <div className="flex flex-col gap-2">
              {["Schuhe", "Hoodies & Pullover", "T-Shirts", "Jacken"].map((cat) => (
                <span key={cat} className="text-background-400 text-xs md:text-sm whitespace-nowrap">{cat}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-100 font-semibold text-sm mb-3">Externe Links</h4>
            <div className="flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-400 hover:text-background-100 text-xs md:text-sm transition-colors whitespace-nowrap"
              >
                OOPBuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-400 hover:text-background-100 text-xs md:text-sm transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet Forum. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4 text-background-500 text-xs">
            <span>Deutschland</span>
            <span>·</span>
            <span>Österreich</span>
            <span>·</span>
            <span>Schweiz</span>
          </div>
        </div>
      </div>
    </footer>
  );
}